import { Heading, Paragraph, Stack } from '@sixfold/common-ui';
import { Localized } from '@sixfold/localization-component';
import * as React from 'react';

import { Footer } from '../../footer/footer';
import { IconEmail } from '../../icons';
import { MapPageFrame } from '../../map_page_frame';

export const SharedViewEmailSent: React.FC<{ email: string }> = ({ email }) => (
  <MapPageFrame showHeader={false} footer={<Footer />}>
    <Stack direction="column" gap="medium" alignItems="center">
      <IconEmail />
      <Heading size="medium" type="display">
        <Localized id="sharedView.login.email.success.title">Check your inbox</Localized>
      </Heading>
      <Paragraph>
        <Localized id="sharedView.login.email.success.details">
          An email with a login link has been sent to <b>{{ email }}</b> if it is associated with any shared views.
        </Localized>
      </Paragraph>
    </Stack>
  </MapPageFrame>
);
